import React from 'react';
import { motion } from 'framer-motion';
export function Description() {
  return <section className="py-24 px-6 bg-nude-light" data-id="element-69">
      <div className="max-w-4xl mx-auto text-center" data-id="element-70">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-71">
          <span className="text-gold uppercase tracking-[0.2em] text-sm font-medium mb-4 block" data-id="element-72">
            La Experiencia Alexa Beauty
          </span>
          <h2 className="text-3xl md:text-5xl font-serif text-luxury-black mb-10 leading-tight" data-id="element-73">
            MÁS QUE UN KIT… <br className="hidden md:block" data-id="element-74" />
            <span className="italic text-gray-500" data-id="element-75">UNA IMAGEN PROFESIONAL</span>
          </h2>

          <div className="space-y-6 text-lg md:text-xl text-gray-600 font-sans font-light leading-relaxed" data-id="element-76">
            <p data-id="element-77">
              Nuestros kits Alexa Beauty fueron creados para mujeres
              profesionales que desean trabajar organizadas, verse elegantes y
              ofrecer una mejor experiencia a sus clientas.
            </p>
            <p data-id="element-78">
              Cada detalle fue pensado para combinar funcionalidad, belleza y
              presencia profesional.
            </p>
            <p className="font-medium text-luxury-black" data-id="element-79">
              No solo compras accesorios… compras presentación, comodidad y
              estilo.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}